// Color constants for Blue Shield of California
const colors = {
  primary: {
    main: '#0071BC',
    secondary: '#7BB9E6',
  },
  secondary: {
    main: '#F5F5F5',
  },
  text: {
    primary: '#000000',
    secondary: '#01619B',
    tertiary: '#FFFFFF',
    muted: '#707275',
  },
  background: {
    default: '#162C55',
    disabled: '#707275',
    lightBlue: '#E4F4F5',
    lightHover: '#F8EDEB',
    matrixHeader: '#E9F4FA',
    lightGray: '#FBF9F7',
    darkGray: '#ECEDED',
  },
  border: {
    unselected: '#707275',
    default: '#B8B9BB',
    error: '#CA1621',
  },
  states: {
    transparent: 'transparent',
  },
  error: {
    bgColor: '#FBF4F4',
    textColor: '#870808',
  },
  success: {
    textColor: '#0E983D',
  },
};

export default colors;
